import { IntlProvider, LocalizationProvider } from '@progress/kendo-react-intl';
import { loadMessages } from '@progress/kendo-react-intl';
import nbMessages from '../../nb.json';
import { NumericTextBox as KendoNumericTextBox } from "@progress/kendo-react-inputs";

loadMessages(nbMessages, 'nb-NO');

export function NumericTextBox({
    value = null,
    min = 0,
    max = undefined,
    steps = 1,
    onChange,
    placeholder = "",
    style = null,
    format = "n2",
    disabled = false
}) {

    return (
        <LocalizationProvider language='nb-NO'>
            <IntlProvider locale='en'>
                <KendoNumericTextBox
                    format={format}
                    style={style}
                    min={min}
                    max={max}
                    steps={steps}
                    placeholder={placeholder}
                    value={value}
                    onChange={onChange}
                    disabled={disabled}
                />
            </IntlProvider>
        </LocalizationProvider>
    );
}

